import { FETCH_FAQ_CONTENT } from '../types'
export default (state = null, action) => {
  switch (action.type) {
    case FETCH_FAQ_CONTENT:
      return action.payload
    default:
      return state;
  }
}